import { useQuery } from "@tanstack/react-query";
import { getTagByName } from "./api";

const Keys = {
  tag: (name) => ["tag", name],
};

export function useGetTagByName({ name, enabled }) {
  return useQuery(Keys.tag(name), () => getTagByName(name), {
    enabled,
  });
}
